// Crosshair HUD (UI-4): a small centered reticle, shown only while the pointer is
// locked and no screen is open, plus an attack-cooldown bar that fills as the
// melee swing recharges (PLR-3 indicator). Client-only (ENG-1). Diff-based: the
// DOM is touched only when a value changes.
import { h } from '../h';
import type { Game } from '../../boot';

export class Crosshair {
  readonly el: HTMLElement;
  private readonly cooldown: HTMLElement;
  private lastShow: boolean | null = null;
  private lastCd = -1;

  constructor() {
    this.cooldown = h('div', { class: 'bb-crosshair-cd' });
    this.el = h('div', { class: 'bb-crosshair' },
      h('div', { class: 'bb-crosshair-h' }),
      h('div', { class: 'bb-crosshair-v' }),
      this.cooldown,
    );
  }

  update(game: Game): void {
    const show = game.locked && !game.uiOpen && !game.chatOpen && game.playerState.gameMode !== 'spectator';
    if (show !== this.lastShow) { this.el.style.display = show ? 'block' : 'none'; this.lastShow = show; }

    // Fill 0→1 as the cooldown drains; hidden (full) when ready.
    const max = game.attackCooldownMax || 1;
    const frac = 1 - Math.min(1, game.attackCooldown / max);
    const q = Math.round(frac * 20) / 20; // quantize to avoid per-frame writes
    if (q !== this.lastCd) {
      this.cooldown.style.width = `${q * 100}%`;
      this.cooldown.style.opacity = q >= 1 ? '0' : '1';
      this.lastCd = q;
    }
  }
}
